import api from "../../api";
import { formatArrayToElSelect } from "./../../utils";

const state = {
  status: "",
  list: [],
  sellers: [],
  sellersEmployee: [],
  sellersEmployeeCodeString: [],
  PaymentAgentEmployeeCode: []
};

const getters = {
  list_to_select: (state, getters, rootState) => {
    let b = [];

    for (let item of state.list) {
      if (item.CompanySelected === rootState.user.user.CompanySelected) {
        b.push({
          label: item.FullName,
          value: item.SalesPersonCode,
          IsEnabled: item.IsEnabled,
          ...item
        });
      }
    }

    return b;
  },
  listSellerBySelector: (state, getters, rootState) => {
    let b = [];

    for (let item of state.list) {
      if (item.CompanySelected === rootState.user.user.CompanySelected) {
        b.push({
          label: item.FullName,
          value: item.Id,
          IsEnabled: item.IsEnabled,
          ...item
        });
      }
    }

    return b;
  },
  getSellerSelector: (state) => {
    return formatArrayToElSelect(state.sellers, {
      label: "FullName"
    });
  },
  getSellerById:
    (state) =>
    ({ id, bySeller = false }) => {
      if (bySeller !== undefined && bySeller) {
        return state.sellers.find((f) => f.value === id);
      }

      return state.sellersEmployee.find((f) => f.value === id);
    },
  getSellersEmployee: (state) => state.sellersEmployee,
  getSellersEmployeeCodeString: (state) => state.sellersEmployeeCodeString,
  getPaymentAgentCode: (state) => state.PaymentAgentEmployeeCode
};

const actions = {
  getItems: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/sellers", {
          timeout: 3000 * 6 * 1000
        })
        .then((resp) => {
          commit("success");
          commit("list", resp.data);
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  fetchSellers: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/sellers")
        .then((resp) => {
          commit("success");
          commit("SET_SELLERS", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  fetchSellersEmployee: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/sellersEmployee")
        .then((resp) => {
          commit("success");
          commit("SET_SELLERS_EMPLOYEE", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  fetchSellersEmployeeCodeString: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/sellersEmployeeCodeString")
        .then((resp) => {
          commit("success");
          commit("SET_SELLERS_EMPLOYEE_Code_String", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  fetchPaymentAgentCode: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/paymentAgentEmployee")
        .then((resp) => {
          commit("success");
          commit("SET_PAYMENT_AGENT_Code", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  }
};

const mutations = {
  loading: (state) => (state.status = "loading"),
  success: (state) => (state.status = "success"),
  error: (state) => (state.status = "error"),
  list: (state, list) => {
    state.list = list;
  },
  SET_SELLERS: (state, payload) => {
    state.sellers = payload;
  },
  SET_SELLERS_EMPLOYEE: (state, payload) => {
    state.sellersEmployee = payload;
  },
  SET_SELLERS_EMPLOYEE_Code_String: (state, payload) => {
    state.sellersEmployeeCodeString = payload;
  },
  SET_PAYMENT_AGENT_Code: (state, payload) => {
    state.PaymentAgentEmployeeCode = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
